import React from 'react';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { StyledIconWrapper, StyledWrapper } from './styles';

export enum EAlertVariants {
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export interface IAlert {
  children?: any;
  text: string;
  textKey?: string;
  variant?: EAlertVariants;
  small?: boolean;
  sx?: any;
}

export const Alert = ({
  children,
  text,
  variant = EAlertVariants.success,
  small = false,
  sx,
}: IAlert) => {
  let icon: EIconTypes;
  let iconBackgroundColor: string;
  let backgroundColor: string;
  let borderColor: string;
  let textColor: string;
  switch (variant) {
    case EAlertVariants.success:
      textColor = colors.success800;
      backgroundColor = colors.success25;
      borderColor = colors.success100;
      iconBackgroundColor = colors.success700;
      icon = EIconTypes.checkmark;
      break;
    case EAlertVariants.warning:
      textColor = colors.warning900;
      backgroundColor = colors.warning25;
      borderColor = colors.warning100;
      iconBackgroundColor = colors.warning700;
      icon = EIconTypes.info;
      break;
    case EAlertVariants.error:
      textColor = colors.error800;
      backgroundColor = colors.error25;
      borderColor = colors.error100;
      iconBackgroundColor = colors.error700;
      icon = EIconTypes.info;
      break;
    default:
      textColor = colors.success600;
      backgroundColor = colors.success50;
      borderColor = colors.success100;
      iconBackgroundColor = colors.success50;
      icon = EIconTypes.info;
  }
  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      small={small}
      style={sx}
    >
      <StyledIconWrapper iconBackgroundColor={iconBackgroundColor} small={small}>
        <Icon type={icon} color={colors.white} fontSize={small ? 12 : 16} />
      </StyledIconWrapper>
      <Typography variant="caption" sx={{ ml: 2, color: textColor }}>
        {text}
        <div className="content" style={{ marginLeft: 2 }}>
          {children}
        </div>
      </Typography>
    </StyledWrapper>
  );
};
